export default __webpack_public_path__ + "static/media/logo_login.2a9c91a2.png";